



























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Button from '@/components/common/elements/Button.vue';

@Component({
  components: { SingleText, Button }
})
export default class StatusStep extends Vue {
  // 現在のステータス名
  @Prop({ default: '' })
  private currentStatus?: string;
  // 表示するステータスリスト
  @Prop({ default: [] })
  private statusList?: Array<string>;
  // 編集可能状態(編集可能状態でボタンイベント使用可、デフォルトでは編集不可)
  @Prop({ default: false })
  private isEditable?: boolean;

  /**
   * 子コンポーネントからEmitされる値を親コンポーネントに
   * （値が渡されるか確認用）
   * @module buttonAction
   * @param {string} type - 押下されたボタンのタイプ
   * @return {string} - 押下されたボタンのタイプ
   */
  @Emit('buttonAction')
  private buttonAction(type: string): string {
    return type;
  }
}
